module.exports = __webpack_public_path__ + "img/brand (27).b39633ea.png";